export const getLoginReferrer = (location = {}) => {
  const locationState = location.state || {}

  if (Object.prototype.hasOwnProperty.call(locationState, 'referrer')) {
    return locationState.referrer
  }

  const searchParams = new URLSearchParams(location.search || '')
  const referrer = searchParams.get('referrer')

  if (referrer) {
    return referrer
  }

  const next = searchParams.get('next')
  return next || ''
}
